import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { CheckManager } from "../../shared/check-manager";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { Campaign } from "../../models/campaign.model";
import { Filter } from "../../models/filter.model";
import { Invite } from "../../models/invite.model";
import { User } from "../../models/user.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { InviteService } from "../../services/invite.service";
import { TeamDataProvider } from "../../data-provider/team.dp";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { InviteDataProvider } from "../../data-provider/invite.dp";
import { Team } from "../../models/team.model";
import { SearchUtils } from "../../helper/search.helper";
import { QrCodeService } from "../../services/qr-code.service";

let InviteListComponent = {
    selector: "vcInviteList",
    templateUrl: "/angular/components/invite/invite-list.component.html",
    bindings: {},
    controller: class InviteListController {
        private $scope: any;
        private userDataProvider: UserDataProvider;
        private filterDataProvider: FilterDataProvider;
        private teamDataProvider: TeamDataProvider;
        private searchUtils: SearchUtils;
        private $q: any;
        private $interval: any;
        private campaignDataProvider: CampaignDataProvider;
        public dataProvider: InviteDataProvider;
        private navigationBarService: NavigationBarHelperService;
        private service: InviteService;
        private dialog: DialogUtils;
        private toast: ToastUtils;
        public permissionProvider: PermissionCheck;
        private __app_type: string;
        private qrCodeService: QrCodeService;

        public filter: Filter;
        public search = "";
        public activeCampaign: Campaign;
        public signedInUser: User;
        public invites: Invite[] = [];
        public searchDelay: any;
        public previousFilter: Filter;
        public isLeaderView: boolean;
        public checkManager: CheckManager;

        constructor(
            $scope: any,
            UserDataProvider: UserDataProvider,
            FilterDataProvider: FilterDataProvider,
            TeamDataProvider: TeamDataProvider,
            SearchUtils: SearchUtils,
            $q: any,
            $interval: any,
            CampaignDataProvider: CampaignDataProvider,
            InviteDataProvider: InviteDataProvider,
            NavigationBarHelperService: NavigationBarHelperService,
            InviteService: InviteService,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            PermissionCheck: PermissionCheck,
            __app_type: string,
            QrCodeService: QrCodeService
        ) {
            this.$scope = $scope;
            this.userDataProvider = UserDataProvider;
            this.filterDataProvider = FilterDataProvider;
            this.teamDataProvider = TeamDataProvider;
            this.searchUtils = SearchUtils;
            this.$q = $q;
            this.$interval = $interval;
            this.campaignDataProvider = CampaignDataProvider;
            this.dataProvider = InviteDataProvider;
            this.navigationBarService = NavigationBarHelperService;
            this.service = InviteService;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.permissionProvider = PermissionCheck;
            this.__app_type = __app_type;
            this.qrCodeService = QrCodeService;

            this.filterDataProvider.setPage("users");
            this.filter = this.filterDataProvider.appliedFilter;
            this.activeCampaign = this.campaignDataProvider.activeCampaign;
            this.checkManager = this.dataProvider.checkManager;
            this.signedInUser = this.userDataProvider.getActiveUser();
            this.isLeaderView = this.__app_type == "LEADER";

            if (this.filter.search && this.filter.search.values) {
                this.searchUtils.searchText = _.cloneDeep(
                    this.filter.search.values
                );
                this.search = this.searchUtils.searchText;
            }

            this.searchUtils.setSearchBar(
                "Search Users",
                (searchText: string) => {
                    this.search = searchText;
                    return this.$q.resolve([]);
                },
                null,
                true
            );

            this.$scope.$watch(
                () => this.search,
                (
                    newValue: string | undefined,
                    oldValue: string | undefined
                ) => {
                    if (oldValue != newValue) {
                        this.dataProvider.loading = true;
                        if (this.searchDelay) {
                            this.searchDelay = this.$interval.cancel(
                                this.searchDelay
                            );
                        }
                        this.searchDelay = this.$interval(() => {
                            this.$interval.cancel(this.searchDelay);
                            this.filterDataProvider.filter.search.values =
                                this.search;
                            this.filter.search.values = _.cloneDeep(
                                this.search
                            );
                            this.dataProvider.setFilter(this.filter);
                        }, 1000);
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.filter,
                (
                    newValue: Filter | undefined,
                    oldValue: Filter | undefined
                ) => {
                    if (
                        !this.previousFilter ||
                        (newValue &&
                            !angular.equals(
                                newValue.nonEmptyValues(),
                                oldValue.nonEmptyValues()
                            )) ||
                        (Object.keys(newValue).length &&
                            !Object.keys(oldValue).length)
                    ) {
                        if (
                            !this.previousFilter &&
                            Object.keys(this.filter.nonEmptyValues()).length > 0
                        ) {
                            this.navigationBarService.setFilterBarOpen(true);
                        }
                        this.previousFilter = _.cloneDeep(newValue);
                        this.dataProvider.setFilter(this.filter);
                    }
                },
                true
            );
        }

        isPending(invite: Invite): boolean {
            return Number(invite.campaigninvitestatusid) === 5;
        }

        approvePending(invite: Invite): void {
            this.qrCodeService
                .approve(invite.campaigninviteid as number)
                .then(
                    () => {
                        this.toast.success("Sign-up approved");
                        this.dataProvider.resetItems();
                    },
                    () => this.toast.error()
                );
        }

        rejectPending(invite: Invite): void {
            this.qrCodeService
                .reject(invite.campaigninviteid as number)
                .then(
                    () => {
                        this.toast.success("Sign-up rejected");
                        this.dataProvider.resetItems();
                    },
                    () => this.toast.error()
                );
        }

        hasPendingSelected(): boolean {
            const ids = this.checkManager.checked_items;
            return this.dataProvider.invites.some(
                (invite: Invite) =>
                    this.isPending(invite) &&
                    ids.indexOf(invite.campaigninviteid) > -1
            );
        }

        private selectedPendingIds(): number[] {
            const ids = this.checkManager.checked_items;
            return this.dataProvider.invites
                .filter(
                    (invite: Invite) =>
                        this.isPending(invite) &&
                        ids.indexOf(invite.campaigninviteid) > -1
                )
                .map((invite: Invite) => invite.campaigninviteid as number);
        }

        // Pending-approval (status 5) self-signups share this list but must not
        // be touched by the standard invite actions — resending would email them
        // an invite and reset them to status 1, activate/deactivate/delete would
        // mutate rows the approve/reject flow owns. They're handled only by
        // bulk_approve/bulk_reject, so every other bulk action operates on this
        // pending-excluded selection.
        private selectedNonPendingIds(): number[] {
            const ids = this.checkManager.checked_items;
            return this.dataProvider.invites
                .filter(
                    (invite: Invite) =>
                        !this.isPending(invite) &&
                        ids.indexOf(invite.campaigninviteid) > -1
                )
                .map((invite: Invite) => invite.campaigninviteid as number);
        }

        bulk_approve(): void {
            const ids = this.selectedPendingIds();
            this.$q
                .all(ids.map((id: number) => this.qrCodeService.approve(id)))
                .then(
                    () => {
                        this.toast.success(ids.length + " sign-ups approved");
                        this.checkManager.checkAll(false);
                        this.dataProvider.resetItems();
                    },
                    () => this.toast.error()
                );
        }

        bulk_reject(): void {
            const ids = this.selectedPendingIds();
            this.$q
                .all(ids.map((id: number) => this.qrCodeService.reject(id)))
                .then(
                    () => {
                        this.toast.success(ids.length + " sign-ups rejected");
                        this.checkManager.checkAll(false);
                        this.dataProvider.resetItems();
                    },
                    () => this.toast.error()
                );
        }

        bulk_add_to_team(ev: any): void {
            this.dialog
                .show({
                    component: "vc-add-to-team",
                    targetEvent: ev,
                    scope: this.$scope,
                    ariaLabel: "Create Point",
                    locals: {},
                })
                .then((team: Team) => {
                    if (team) {
                        this.teamDataProvider
                            .addToTeam(
                                [],
                                team,
                                this.dataProvider.checkManager.checked_items
                            )
                            .then(
                                () => {
                                    angular.forEach(
                                        this.dataProvider.invites,
                                        (invite: Invite) => {
                                            if (
                                                this.checkManager.checked_items.indexOf(
                                                    invite.campaigninviteid
                                                ) > -1
                                            ) {
                                                let tids = invite.teams.map(
                                                    (item: Team) => {
                                                        return item["tid"];
                                                    }
                                                );
                                                if (
                                                    tids.indexOf(team.tid) == -1
                                                ) {
                                                    invite.teams.push(team);
                                                }
                                            }
                                        }
                                    );

                                    this.toast.success(
                                        this.checkManager.checked_items_count +
                                            " invites added to " +
                                            team.tname
                                    );
                                    this.checkManager.checkAll(false);
                                },
                                () => this.toast.error()
                            );
                    }
                });
        }

        bulk_delete(ev: any): void {
            const ids = this.selectedNonPendingIds();
            if (!ids.length) {
                return;
            }
            const count = ids.length;

            this.dialog
                .delete({
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        title: `Delete ${count} ${
                            count > 1 ? "invites" : "invite"
                        }?`,
                        bodyText: `${
                            count > 1 ? "These invites" : "This invite"
                        } will be permanently deleted`,
                    },
                })
                .then(() => {
                    this.dataProvider
                        .bulkDelete(ids)
                        .then(
                            () =>
                                this.toast.success(count + " invites deleted"),
                            () => this.toast.error()
                        );
                });
        }

        bulk_resend(ev: any): void {
            const ids = this.selectedNonPendingIds();
            if (!ids.length) {
                return;
            }
            const count = ids.length;
            const invites = count > 1 ? "Invites" : "Invite";

            const bulkResendModal = this.dialog
                .confirm()
                .title(`Resend ${count} ${invites}?`)
                .textContent(
                    "Advise new users to check their junk/spam folder if they can't find their invite email"
                )
                .targetEvent(ev)
                .multiple(true)
                .cancel("Cancel")
                .ok("Resend");

            this.dialog.showPreConfiguredDialog(bulkResendModal).then(() => {
                this.dataProvider
                    .bulkResend(ids)
                    .then(
                        () => this.toast.success(count + " invites resent"),
                        () => this.toast.error()
                    );
            });
        }

        openInviteDialog(invite: Invite, $event: any): void {
            if (invite.teams.length) {
                invite.team = invite.teams[0];
            }
            this.dialog.show({
                component: "vc-update-user-dialog",
                targetEvent: $event,
                clickOutsideToClose: false,
                size: "large",
                scope: this.$scope,
                locals: {
                    user: invite,
                },
            });
        }

        deleteInvite(invite: Invite, ev: any): void {
            this.dialog
                .delete({
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        title: "Delete Invite?",
                        bodyText: "It will be permanently deleted",
                    },
                })
                .then(
                    () => {
                        this.service
                            .remove({ id: invite.campaigninviteid })
                            .then((response: object) => {
                                const json = response["data"];
                                if (json.success) {
                                    this.invites.forEach(
                                        (item: Invite, index: number) => {
                                            if (
                                                (json.data
                                                    .campaigninviteemail &&
                                                    item.campaigninviteemail ===
                                                        json.data
                                                            .campaigninviteemail) ||
                                                (json.data
                                                    .campaigninvitephonenumber &&
                                                    item.campaigninvitephonenumber ===
                                                        json.data
                                                            .campaigninvitephonenumber &&
                                                    item.campaigninvitecountrycode ===
                                                        json.data
                                                            .campaigninvitecountrycode)
                                            ) {
                                                this.invites.splice(index, 1);
                                            }
                                        }
                                    );
                                }
                            });
                    },
                    () => this.toast.error()
                );
        }

        resendInvite(invite: Invite, $event: any): void {
            if (invite.campaigninviteemail) {
                invite.deliverystatus = "Sent";
            } else {
                invite.sms.deliverystatus = "0";
            }
            this.toast.success("Invite sent.");
            this.service.resend(invite).then((response: object) => {
                const json = response["data"];
                if (json.success) {
                    invite.setData(json.data);
                } else {
                    this.toast.error();
                }
            });
        }

        updateAfterActivation(): void {
            this.checkManager.checkAll(false);
            this.userDataProvider.resetStats();
            this.dataProvider.resetItems();
        }

        activate(invite: Invite, ev: any): void {
            this.userDataProvider
                .confirmActivateDialog([], [invite], ev)
                .then(() => {
                    this.updateAfterActivation();
                });
        }

        deactivate(invite: Invite, ev: any): void {
            this.userDataProvider
                .activateUsers([], [invite.campaigninviteid], 0)
                .then(() => {
                    this.updateAfterActivation();
                });
        }

        bulk_activate(ev: any): void {
            const invites = this.dataProvider.invites.filter(
                (item: Invite) =>
                    (!item.seated || item.seated == "0") &&
                    item.checked &&
                    !this.isPending(item)
            );
            this.userDataProvider
                .confirmActivateDialog([], invites, ev)
                .then(() => {
                    this.updateAfterActivation();
                });
        }

        bulk_deactivate(ev: any): void {
            const invites = this.dataProvider.invites.filter(
                (invite: Invite) => {
                    if (
                        invite.seated == "1" &&
                        invite.checked &&
                        !this.isPending(invite)
                    )
                        return invite;
                }
            );
            this.userDataProvider
                .deactivateUsers([], invites, ev)
                .then(() => this.updateAfterActivation());
        }
    },
};

angular
    .module("invite", [])
    .component(InviteListComponent.selector, InviteListComponent);
